/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { GetMonthNorms$Params, getMonthNorms } from '../fn/weather/get-month-norms';
import { GetMonthStats$Params, getMonthStats } from '../fn/weather/get-month-stats';
import { GetStats$Params, getStats } from '../fn/weather/get-stats';
import { GetWeathers$Params, getWeathers } from '../fn/weather/get-weathers';
import { WeatherStationData } from '../models/weather-station-data';
import { WeatherStationDataMonthStat } from '../models/weather-station-data-month-stat';
import { WeatherStationDataStat } from '../models/weather-station-data-stat';

/**
 * Weather API
 */
@Injectable({ providedIn: 'root' })
export class WeatherService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getWeathers()` */
   static readonly GetWeathersPath = '/api/weather/weather';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getWeathers()` instead.
    *
    * This method doesn't expect any request body.
    */
   getWeathers$Response(
      params?: GetWeathers$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Array<WeatherStationData>>> {
      return getWeathers(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getWeathers$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getWeathers(params?: GetWeathers$Params, context?: HttpContext): Observable<Array<WeatherStationData>> {
      return this.getWeathers$Response(params, context).pipe(
         map((r: StrictHttpResponse<Array<WeatherStationData>>): Array<WeatherStationData> => r.body)
      );
   }

   /** Path part for operation `getMonthNorms()` */
   static readonly GetMonthNormsPath = '/api/weather/weather/monthNorms';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getMonthNorms()` instead.
    *
    * This method doesn't expect any request body.
    */
   getMonthNorms$Response(
      params: GetMonthNorms$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Array<WeatherStationDataMonthStat>>> {
      return getMonthNorms(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getMonthNorms$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getMonthNorms(params: GetMonthNorms$Params, context?: HttpContext): Observable<Array<WeatherStationDataMonthStat>> {
      return this.getMonthNorms$Response(params, context).pipe(
         map((r: StrictHttpResponse<Array<WeatherStationDataMonthStat>>): Array<WeatherStationDataMonthStat> => r.body)
      );
   }

   /** Path part for operation `getMonthStats()` */
   static readonly GetMonthStatsPath = '/api/weather/weather/monthStats';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getMonthStats()` instead.
    *
    * This method doesn't expect any request body.
    */
   getMonthStats$Response(
      params: GetMonthStats$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Array<WeatherStationDataMonthStat>>> {
      return getMonthStats(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getMonthStats$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getMonthStats(params: GetMonthStats$Params, context?: HttpContext): Observable<Array<WeatherStationDataMonthStat>> {
      return this.getMonthStats$Response(params, context).pipe(
         map((r: StrictHttpResponse<Array<WeatherStationDataMonthStat>>): Array<WeatherStationDataMonthStat> => r.body)
      );
   }

   /** Path part for operation `getStats()` */
   static readonly GetStatsPath = '/api/weather/weather/stats';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getStats()` instead.
    *
    * This method doesn't expect any request body.
    */
   getStats$Response(
      params: GetStats$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Array<WeatherStationDataStat>>> {
      return getStats(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getStats$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getStats(params: GetStats$Params, context?: HttpContext): Observable<Array<WeatherStationDataStat>> {
      return this.getStats$Response(params, context).pipe(
         map((r: StrictHttpResponse<Array<WeatherStationDataStat>>): Array<WeatherStationDataStat> => r.body)
      );
   }
}
